@if (!isLoading) {
  <ziro-order-view-and-edit
    [companyId]="companyId"
    [isUserS8Support]="isSupportUser"
    [currentUser]="currentUser"
  ></ziro-order-view-and-edit>
}
